import React from 'react';
import { CircularProgress, Box } from '@mui/material';

/**
 * Generic spinner while waiting for API response on open of a page (i.e. a GET call)
 */
const LoadingSpinner = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '60vh' }}
    >
      <CircularProgress size={48} />
    </Box>
  );
};

export default LoadingSpinner;
